var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 15.1667C6.59695 15.1667 6 14.5698 6 13.8334V7.8343C6 7.09756 6.59753 6.50046 7.33427 6.50098L13.3343 6.50521C14.0703 6.50573 14.6667 7.10253 14.6667 7.83857V13.8334C14.6667 14.5698 14.0697 15.1667 13.3333 15.1667H7.33333Z",
    stroke: "#B0B0B0",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 6.11901V3.17268C11.3334 2.43666 10.737 1.83986 10.001 1.83934L2.66764 1.83423C1.93089 1.83372 1.33337 2.43082 1.33337 3.16756V10.5C1.33337 11.2364 1.93033 11.8333 2.66671 11.8333H5.61909",
    stroke: "#B0B0B0",
    strokeWidth: 1.7,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.57537a191e2cd4720c7de7a8eb36193f.svg";
export { ForwardRef as ReactComponent };